import _ from 'underscore';
import { useContext, useMemo } from 'react';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { areaTargetNameTypeComboGenerator } from '@bingads-webui-campaign-react/location-targeting';
import { campaignLanguageStrings } from '@bingads-webui-campaign-react/language-target';
import { parseDateFromAPIFormat } from '@bingads-webui-campaign-react/linkedin-data';

const formatLanguage = (i18n, language) => (language
  ? i18n.getString(campaignLanguageStrings[language])
  : i18n.getString('No language targeted'));

const formatLocations = (i18n, locationTargets) =>
  _.chain(locationTargets)
    .get('positiveLocationTargets', [])
    .map(loc => areaTargetNameTypeComboGenerator(i18n, {
      name: loc.location.ExpandedName,
      type: loc.location.Type,
      countryCode: loc.location.CountryCode,
    }))
    .compact()
    .value();

const formatAudiences = audienceTargets =>
  _.mapObject(audienceTargets, targets => _.pluck(targets, 'name'));

export const useSummarySchemaData = ({ data }) => {
  const i18n = useContext(I18nContext);
  const globalI18n = useMemo(() => window.globalLegacyI18n.get('$/i18n!legacy/global'), []);

  if (!data) { return {}; }

  return ({
    adCount: {
      numAds: data.numAds,
    },
    adScheduleAdGroup: {
      startDate: parseDateFromAPIFormat(i18n, data.adGroup.StartDate),
      endDate: parseDateFromAPIFormat(i18n, data.adGroup.EndDate),
    },
    bidStrategy: {
      data: data.campaign.BiddingScheme,
    },
    budget: {
      data: data.campaign.Budget,
      currencyCode: data.currencyCode,
    },
    campaignName: {
      data: data.campaign.Name,
    },
    companyInfo: data.companyInfo,
    languageTargeting: {
      data: formatLanguage(i18n, data.campaign.Languages[0]),
    },
    linkedInAudienceTargeting: formatAudiences(data.audienceTargets),
    locationTargeting: {
      locations: formatLocations(globalI18n, data.locationTargets),
    },
    genderTargeting: {
      genders: data.genderTargets,
    },
    ageRangeTargeting: {
      ageRanges: data.ageTargets,
    },
    goalCount: {
      numGoals: data.numGoals,
    },
    conversionGoals: data.conversionGoals,
  });
};
